import axios from 'axios';

const instanceChatBot = axios.create({
  baseURL: process.env.REACT_APP_API_CHATBOT,
  headers: {
    'Content-Type': 'application/json',
    Accept: '/',
  },
});

export const createSession = (data: any) => instanceChatBot.post('/sessions', data);

export const sendChatMessage = (data: any) => instanceChatBot.post('/chat', data);

export const getSessions = (userId: string, limit: number) =>
  instanceChatBot.get(`/sessions/${userId}${limit ? `?limit=${limit}` : ''}`);

export const getSessionHistory = (sessionId: string, limit: number) =>
  instanceChatBot.get(`/sessions/${sessionId}/history${limit ? `?limit=${limit}` : ''}`);

export const updateSessionTitle = (sessionId: string, data: any) =>
  instanceChatBot.put(`/sessions/${sessionId}/title`, data);

export const deleteSession = (sessionId: string, data: any) =>
  instanceChatBot.delete(`/sessions/${sessionId}`, { data });

export const sendChatMessageStream = async (data: any) => {
  const response = await fetch(`${instanceChatBot.defaults.baseURL}/chat/stream`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      'Cache-Control': 'no-cache',
    },
    body: JSON.stringify(data),
  });

  return response;
};
